import {
  AddPage,
  EditPage,
  TablePage,
  ViewPage,
} from 'src/views/logisticsadmin/clogsconfig'

import pathMap from 'src/paths/PathMap_LogisticsAdmin'

class ClogsConfigRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CLOGS_CONFIG_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.CLOGS_CONFIG_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.CLOGS_CONFIG_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.CLOGS_CONFIG_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default ClogsConfigRoute
